angular.module('iqxCore')
.controller('NoPermissionCtrl', function ($scope, $routeParams) {
	if ($routeParams.perms) {
		$scope.permissionsMissing=$routeParams.perms.split(",")
	}	
})
